export default "__VITE_ASSET__CjY9OKD3__"